const scientificNames = [
    "Streptococcus pneumoniae",
    "Neisseria meningitidis",
    "Plasmodium falciparum",
    "Clostridium tetani",
    "Haemophilus influenzae",
    "Bordetella pertussis",
    "Vibrio cholerae",
    "Salmonella Typhi",
    "Mycobacterium tuberculosis",
    "Corynebacterium diphtheriae",
    "Bacillus anthracis",
    "Clostridium difficile",
    "Escherichia coli",
    "Borrelia burgdorferi",
    "H. influenzae",
    "N. meningitidis",
    "M. tuberculosis",
    "S. pneumoniae",
    "B. anthracis",
    "P. Falciparum",
    "V. cholerae",
    "Zaire ebolavirus",
    "N meningitidis",
    "Spodoptera frugiperda",
    "Salmonella Paratyphi"
];

export default scientificNames;